import { dispatcher, ingenuity } from "@quest/base-core";
import { IntroOutroViewBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class IntroOutroViewGame extends IntroOutroViewBehavior {
    // to avoid changing parent of text container 
    protected changeIntroMeterParent() {
        //
    }
    public addOnTop(): void {
        ingenuity.currentGame.stage.addChild(this);
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    }
}